<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div id="map" v-bind:style="{width: width + '%', height: height + 'px'}" class="map"></div>
      </div>
    </div>
  </div>
</template>
<script>

// eslint-disable-next-line to ignore the next line.
/* eslint-disable */


import {LMap, LTileLayer, LMarker, LPolygon} from 'vue2-leaflet'
// import L from 'leaflet';
// import 'leaflet/dist/leaflet.css'
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package

import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css'; // Re-uses images from ~leaflet package
import 'leaflet-geosearch/assets/css/leaflet.css';
import * as L from 'leaflet';
import * as LD from 'leaflet-draw';
import * as LE from 'esri-leaflet';
import 'leaflet-defaulticon-compatibility';
// import {required} from 'vuelidate/lib/validators';
import { GoogleProvider, OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';

import FilterModel from '@/shared/filter';
// import initPageFilterModel from '@/shared/filters/pageFilter';

// import VGeosearch from 'vue2-leaflet-geosearch';

import $ from 'jquery';

export default {
  components: {LMap, LTileLayer, LMarker, LPolygon},
  data() {
    return {
      map: null,
      tileLayer: null,
      drawnItems: null,
      target: {
        latitude: null,
        longitude: null
      },
      loading: false,
      div1Class: 'col-sm-11',
      div2Class: 'col-sm-1',
      filter: new FilterModel(),
      locationData: null,
      buildingPhotos: [],
      nextIndex: 0
    }
  },
  props: {
    realEstateId: Number,
    dataSource: Object,
    editable: {
      type: Boolean,
      default: true
    },
    marker: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 550
    },
    width: {
      type: Number,
      default: 100
    }
  },
  methods: {
    setMarkerData(latitude, longitude) {
      const vm = this;
      vm.target = {
        latitude: latitude,
        longitude: longitude
      };

      this.$emit("input", vm.target);
    },
    setMarkerLatLng(marker, lat, lng){
      const vm = this;
      var customOptions = {
        'maxWidth': '500',
        'className': ''
      };

      marker.on('dragend', function() {
        console.log(marker.getLatLng());
        const lat = marker.getLatLng().lat;
        const lng = marker.getLatLng().lng;
        vm.setMarkerData(lat, lng);
      });

      vm.setMarkerData(lat, lng);
      let bounds = L.latLngBounds([]);
      let corner = L.latLng(lat, lng);
      bounds.extend(corner);
      this.map.fitBounds(bounds)
    },
    initMap() {
      const vm = this;
      setTimeout(() => {
        const osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        const osmAttrib = '&copy; <a href="http://openstreetmap.org/copyright">OpenStreetMap</a> contributors';
        const osm = L.tileLayer(osmUrl, {maxZoom: 18, attribution: osmAttrib});
        this.map = new L.Map('map', {center: new L.LatLng(41.311264, 69.272057), zoom: 13});
        this.drawnItems = L.featureGroup().addTo(this.map);

        L.control.layers({
          'osm': osm.addTo(this.map),
          "google": L.tileLayer('https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}', {
            attribution: 'google'
          }),
          "grayscale": L.tileLayer('https://api.mapbox.com/styles/v1/johnmichel/ciobach7h0084b3nf482gfvvr/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoiam9obm1pY2hlbCIsImEiOiJjaW9iOW1vbHUwMGEzdnJseWNranhiMHpxIn0.leVOjMBazNl6v4h9MT7Glw', {
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
            maxZoom: 18
          })
        }, {'drawlayer': this.drawnItems}, {position: 'topleft', collapsed: false}).addTo(this.map);


        this.map.addControl(new L.Control.Draw({
          draw: {
            polygon: false,
            polyline: false,
            rectangle: false,
            circle: false,
            circlemarker: false,
            marker: this.marker,
          }
        }));

        this.map.on(L.Draw.Event.CREATED, function (event) {
          var layer = event.layer;
          if (layer.editing._marker) {
            if (!(vm.target && vm.target.latitude != null && vm.target.longitude != null)) {
              const marker = L.marker([layer._latlng.lat, layer._latlng.lng], {draggable: true}).addTo(vm.map);
              vm.setMarkerLatLng(marker, layer._latlng.lat, layer._latlng.lng);
            } else {
              vm.$swal({
                title: "Хато",
                text: "Marker faqat bitta no'qtaga bo'lishi shart!",
                type: 'error'
              });
            }
          }
        });

        this.map.on('click', function(e) {
          var popLocation= e.latlng;
          console.log(popLocation);
        });

        const provider = new OpenStreetMapProvider({params: {}});
        const searchControl = new GeoSearchControl({
          provider: provider,                               // required
          showMarker: true,                                   // optional: true|false  - default true
          showPopup: false,                                   // optional: true|false  - default false
          marker: {                                           // optional: L.Marker    - default L.Icon.Default
            icon: new L.Icon.Default(),
            draggable: false,
          },
          popupFormat: ({ query, result }) => result.label,   // optional: function    - default returns result label
          maxMarkers: 1,                                      // optional: number      - default 1
          retainZoomLevel: false,                             // optional: true|false  - default false
          animateZoom: true,                                  // optional: true|false  - default true
          autoClose: false,                                   // optional: true|false  - default false
          searchLabel: 'Enter address',                       // optional: string      - default 'Enter address'
          keepResult: false                                   // optional: true|false  - default false
        });

        this.map.addControl(searchControl);

      }, 200);
    },
    setData() {
      setTimeout(() => {
        if (this.$props.dataSource && this.$props.dataSource !== null) {
          const marker = L.marker([this.$props.dataSource.latitude, this.$props.dataSource.longitude], {draggable: this.editable});
          marker.addTo(this.map);
          this.setMarkerLatLng(marker, this.$props.dataSource.latitude, this.$props.dataSource.longitude);
        }
      }, 1000);
    },
    setLocationData() {

      const buildings = this.locationData.buildings;

      if (this.locationData.geom && this.locationData.geom.features && this.locationData.geom.features.length > 0) {

        let bounds = L.latLngBounds([]);
        const polygon = L.geoJSON(this.locationData.geom, {
          onEachFeature: function (feature, layer) {
            layer.setStyle({
              fillOpacity: 0.09,
              fillColor: "#0089ff",
              color: "#ff0000",
              opacity: 0.7
            })
          }
        })

        polygon.addTo(this.map)
        this.map.fitBounds(polygon.getBounds(), {
          animate: true,
          duration: 1,
          easeLinearity: 0
        })

        const layerBounds = polygon.getBounds();
        bounds.extend(layerBounds);

      }

      if (buildings.length > 0) {
        const building = buildings[0];
        const coordinate = building.coordinate;

        const marker = L.marker([coordinate.x, coordinate.y], {});
        marker.addTo(this.map);
        this.setMarkerLatLng(marker, coordinate.x, coordinate.y);

        const filePath = building.file && building.file.filePath ? building.file.filePath : '';

        var imgIndex = 0;

        // specify popup options
        var customOptions = {
          // 'maxWidth': '500',
          'width': '100%',
          'minWidth': '100%',
          'className': ''
        };

        var container = $('<div style="width: 320px"/>');

        // container.html("This is a link: <a href='#' class='smallPolygonLink'>Click me</a>.");
        const preBtn = "<div class='col'><button type='button' class='btn btn-outline-info btn-sm fc-icon-left-single-arrow prev'></button></div>";
        const nextBtn = "<div class='col'><button type='button' class='btn btn-outline-info btn-sm fc-icon-right-single-arrow next'></button></div>";
        const img = "<a id='a_filePath' href='" + filePath + "' target='_blank'><img id='filePath' src='" + filePath + "' alt='' height='180px' /></a>"
            + "<span class='right red' id='imageIndex' >" + "<br>№ " + (imgIndex + 1) + ", coordinate: " + coordinate.x + " " + coordinate.y + "</span>";
        const div = "<div class='row'>" +
            "<div class='col'>" + img + "</div>" +
            "</div>";
        const div2 = "<div class='row'>" +
            "<div>" + preBtn + "</div>" +
            "<div>" + nextBtn + "</div>" +
            "</div>";

        const divHeader =
            "<div class='col col-sm-10'>" +
            "<b>№ " + building.realEstateId + " " + building.realEstateName + " (Расмлар: " + buildings.length + ")"
            + "</div>";

        container.html("<div>" + divHeader + div + div2 + "</div>");

        container.on('click', '.prev', function () {
          console.log("prev");
          if (imgIndex <= 0) {
            return;
          }

          const building = buildings[--imgIndex];
          const coordinate = building.coordinate;
          console.log(building);
          console.log(imgIndex);
          const filePath = building.file && building.file.filePath ? building.file.filePath : '';
          $("#imageIndex").html("<br>№ " + (imgIndex + 1) + ", coordinate: " + coordinate.x + " " + coordinate.y);
          $("#filePath").attr("src", filePath);
          $("#a_filePath").attr("href", filePath);
          // $("#filePath").attr("src", "https://api.baxolash.uz/resources/auto/газель-62bc0e2f-7bf7-4b1c-a83c-bda9e85c80ee.PNG");
        });
        container.on('click', '.next', function () {
          console.log("next");
          if (imgIndex === buildings.length - 1) {
            return;
          }
          const building = buildings[++imgIndex];
          const coordinate = building.coordinate;
          console.log(building);
          console.log(imgIndex);
          const filePath = building.file.filePath;
          $("#imageIndex").html("<br>№ " + (imgIndex + 1) + ", coordinate: " + coordinate.x + " " + coordinate.y);
          $("#filePath").attr("src", filePath);
          $("#a_filePath").attr("href", filePath);
        });

        marker.bindPopup(container[0], customOptions);
      }
    },
    initData() {
      const id = this.$route.params.id;
      if (id && id > 0) {
        this.$http.get(`/map/real-estate/${id}`)
            .then(res => {
              if (res.data) {
                this.locationData = res.data;
                setTimeout(() => {
                  this.setLocationData();
                }, 1000);
              }
            }, err => {
              console.log(err);
            });
      }
    }
  },
  created() {
    this.initData();
    this.initMap();
    this.setData();
  },
  watch: {
    // Watch for value change
    'newPolygon.shoppingComplex': {
      immediate: true,
      // handle the changed value
      handler(val) {
        console.log('watch_val', val);
      }
    },
    'dataSource': {
      immediate: true,
      // handle the changed value
      handler(val) {
        // if (val!==null || val) {
        //     console.log('dataSource val', val);
        //     var marker = L.marker([val.latitude, val.longitude], {draggable: true});
        //     marker.addTo(this.map);
        //     this.setMarkerLatLng(marker, val.latitude, val.longitude);
        // }
      }
    }
  }
}
</script>
<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/leaflet.draw/0.4.2/leaflet.draw.css"/>-->
<!--<link  href="https://unpkg.com/leaflet-geosearch@2.7.0/assets/css/leaflet.css" rel="stylesheet" />-->

<style scoped>
.leaflet-right .leaflet-control-geosearch form {
  right: 28px;
  left: initial;
  border-radius: 4px 0 0 4px;
  border-left: inherit;
  border-right: none;
}

</style>